import axios from "../../../axios";
        
      export const uploadProfilePic = async (file,path) => {
        try {            
          let formData = new FormData();
          formData.append('bot-file', file);
          let { data } = await axios.post(`${window._env.REACT_APP_EMCONSOLE_API_URL}/v1/organization/users/upload`, formData);          
          return data
        } catch (err) {
          console.log(err);
      }
    }
      